import { Descriptions, Badge, PageHeader, Select, Checkbox, Space, Button, InputNumber, Popconfirm, message, Form } from 'antd'
import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import { getYears, getCurrentProjectYear, getPreviousProjectYear, saveCurrentYearSettings, saveLastYearSettings, increment } from '../util/APIUtils';
import './ProjectSettings.css';


export class ProjectSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year: null,
            loading: false,
            projectYears: [],
            currentProjectYear: null,
            previousProjectYear: null,
            editing: false,
            editing1: false,
            editing2: false,
            showAllYears: false,
            originalRates: { researcherRate: 0, helperRate: 0, fgRate: 0 },
            projectYear: null,
            // currentPhase: null,
            // enableFgComments: null,
            // showPayoutAmount: null,
            // enableFgBudget: null,
            // enableZsl: null
        };
    }

    handleBack = e => {
        this
            .props
            .history
            .goBack();
        // this.props.history.push('/projects');
    };

    onChange = () => {

    }

    fetchYears = () => {
        this.setState({ loading: true })
        let promise;
        promise = getYears();
        if (!promise) {
            return;
        }

        promise.then(response => {
            console.log(response);
            this.setState({
                loading: false,
                projectYears: response.reverse()
            })

        }).catch(error => {
            this.setState({ loading: false })
        });
    }

    incrementYear = () => {
        this.setState({ loading: true })
        let promise;
        promise = increment();
        if (!promise) {
            return;
        }

        promise.then(response => {
            console.log("Increment response:", response);

            // Check if response is valid
            if (!response || Object.keys(response).length === 0) {
                message.error("Fehler: Projektjahr kann nicht erhöht werden. Möglicherweise ist die Bedingung nicht erfüllt (nächstes Jahr muss aktuelles Kalenderjahr + 1 sein).");
                this.setState({ loading: false });
                return;
            }

            this.setState({
                loading: false,
                currentProjectYear: response
            })
            message.success("Projektjahr erfolgreich erhöht!");
            window.location.reload();

        }).catch(error => {
            console.error("Fehler beim Erhöhen des Projektjahres:", error);
            message.error(error.message || "Fehler beim Erhöhen des Projektjahres");
            this.setState({ loading: false })
        });
    }

    getCurrentYear = () => {
        this.setState({ loading: true })
        let promise;
        promise = getCurrentProjectYear();
        if (!promise) {
            return;
        }

        promise.then(response => {
            console.log(response);
            this.setState({
                loading: false,
                currentProjectYear: response
            })

        }).catch(error => {
            this.setState({ loading: false })
        });
    }

    getPreviousYear = () => {
        this.setState({ loading: true })
        let promise;
        promise = getPreviousProjectYear();
        if (!promise) {
            return;
        }

        promise.then(response => {
            console.log(response);
            this.setState({
                loading: false,
                previousProjectYear: response
            })

        }).catch(error => {
            this.setState({ loading: false })
        });
    }

    saveCurrentYear = (projectYear, type) => {
        this.setState({ loading: true })
        let promise;
        if(type == 1) {
            promise = saveCurrentYearSettings(projectYear);
        } else {
            promise = saveLastYearSettings(projectYear);
        }
        
        if (!promise) {
            return;
        }

        promise.then(response => {
            if(response) {
                message.success("Projekteinstellungen aktualisiert")
            }
            
            this.setState({
                loading: false,
                editing: false,
                editing1: false,
                currentProjectYear: response
            })

        }).catch(error => {
            this.setState({ loading: false })
        });
    }

    componentDidMount() {
        this.fetchYears();
        this.getCurrentYear();
        this.getPreviousYear();
    }


    setEditing = (edit) => {
        this.setState({
            editing: edit
        })
    }

    setEditing1 = (edit) => {
        this.setState({
            editing1: edit
        })
    }


    handleChange = (name, type, value) => {
        console.log(name)
        console.log(value)

        if (type === "check") {
            value = value.target.checked;
        }

        this.setState({ currentProjectYear: { ...this.state.currentProjectYear, [name]: value } });
        console.log(this.state.currentProjectYear)
    };

    handleChange1 = (name, type, value) => {
        console.log(name)
        console.log(value)

        if (type === "check") {
            value = value.target.checked;
        }

        this.setState({ previousProjectYear: { ...this.state.previousProjectYear, [name]: value } });
        console.log(this.state.previousProjectYear)
    };

    handleSave = () => {
        let currentYear = {
            "id": this.state.currentProjectYear.id,
            "projectYear": this.state.currentProjectYear.projectYear,
            "currentPhase": this.state.currentProjectYear.currentPhase,
            "enableFgComments": this.state.currentProjectYear.enableFgComments,
            "showPayoutAmount": this.state.currentProjectYear.showPayoutAmount,
            "enableFgBudget": this.state.currentProjectYear.enableFgBudget,
            "enableZsl": this.state.currentProjectYear.enableZsl,
            "researcherRate": this.state.currentProjectYear.researcherRate,
            "helperRate": this.state.currentProjectYear.helperRate,
            "fgRate": this.state.currentProjectYear.fgRate,
        }
        this.saveCurrentYear(currentYear, 1);
    }

    handleSave1 = () => {
        let currentYear = {
            "id": this.state.previousProjectYear.id,
            "projectYear": this.state.previousProjectYear.projectYear,
            "currentPhase": this.state.previousProjectYear.currentPhase,
            "enableFgComments": this.state.previousProjectYear.enableFgComments,
            "showPayoutAmount": this.state.previousProjectYear.showPayoutAmount,
            "enableFgBudget": this.state.previousProjectYear.enableFgBudget,
            "enableZsl": this.state.previousProjectYear.enableZsl,
            "researcherRate": this.state.previousProjectYear.researcherRate,
            "helperRate": this.state.previousProjectYear.helperRate,
            "fgRate": this.state.previousProjectYear.fgRate,
        }
        this.saveCurrentYear(currentYear, -1);
    }

    startEditingRates = () => {
        this.setState({
            editing2: true,
            originalRates: {
                researcherRate: this.state.currentProjectYear.researcherRate,
                helperRate: this.state.currentProjectYear.helperRate,
                fgRate: this.state.currentProjectYear.fgRate
            }
        });
    }

    cancelEditingRates = () => {
        this.setState({
            editing2: false,
            currentProjectYear: {
                ...this.state.currentProjectYear,
                researcherRate: this.state.originalRates.researcherRate,
                helperRate: this.state.originalRates.helperRate,
                fgRate: this.state.originalRates.fgRate
            }
        });
    }

    handleSaveRates = () => {
        const is2027OrLater = this.state.currentProjectYear.projectYear >= 2027;
        let currentYear = {
            "id": this.state.currentProjectYear.id,
            "projectYear": this.state.currentProjectYear.projectYear,
            "currentPhase": this.state.currentProjectYear.currentPhase,
            "enableFgComments": this.state.currentProjectYear.enableFgComments,
            "showPayoutAmount": this.state.currentProjectYear.showPayoutAmount,
            "enableFgBudget": this.state.currentProjectYear.enableFgBudget,
            "enableZsl": this.state.currentProjectYear.enableZsl,
            "researcherRate": this.state.currentProjectYear.researcherRate,
            "helperRate": is2027OrLater ? 0 : this.state.currentProjectYear.helperRate,
            "fgRate": this.state.currentProjectYear.fgRate,
        }
        this.saveCurrentYear(currentYear, 1);
    }

    toggleShowAllYears = () => {
        this.setState({
            showAllYears: !this.state.showAllYears
        });
    }

    cancelPop = () => {
        this.setState({
            loading: false,
        })
    }


    render() {
        return (
            <div>
                <PageHeader
                    className="site-page-header"
                    title={"Projekt Einstellungen"}
                    extra={<Link to="/access-override"><Button key="3" type="primary" >Access Override</Button></Link>}
                    // extra={this.state.editing ? <Space><Button type='primary' onClick={this.handleSave}>Save</Button><Button onClick={() => this.setEditing(false)} type=''>Cancel</Button></Space> : <Button onClick={() => this.setEditing(true)} type='primary'>Edit</Button>}
                />
                {/* <AccessOverride /> */}
                {this.state.currentProjectYear && this.state.previousProjectYear && 
                <div>
                    <Descriptions layout="vertical" bordered loading={this.state.loading} column={4}>
                    <Descriptions.Item label="Projektjahr" style={{width: "250px"}}>
                        <Select
                            style={{
                                width: '150px'
                            }}
                            disabled
                            name="year"
                            placeholder={"Jahr"}
                            onChange={(val) => this.handleChange("projectYear", null, val)}
                            defaultValue={this.state.currentProjectYear.projectYear}>
                            {this
                                .state
                                .projectYears
                                .map(item => (
                                    <Select.Option key={item.projectYear} value={item.projectYear}>
                                        {item.projectYear}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Descriptions.Item>
                    <Descriptions.Item label="Phase" style={{width: "300px"}}>
                        <Select
                            style={{
                                width: '250px'
                            }}
                            name="currentPhase"
                            disabled={!this.state.editing}
                            placeholder={"Phase"}
                            onChange={(val) => this.handleChange("currentPhase", null, val)}
                            defaultValue={this.state.currentProjectYear.currentPhase}>
                            <Select.Option key={"1"} value={1}>
                                Plan
                            </Select.Option>
                            <Select.Option key={"2"} value={2}>
                            FG Evaluation 1
                            </Select.Option>
                            <Select.Option key={"3"} value={3}>
                            FG Änderungen
                            </Select.Option>
                            <Select.Option key={"4"} value={4}>
                            FG Evaluation 2
                            </Select.Option>
                            <Select.Option key={"5"} value={5}>
                            Vorstandsbewilligung
                            </Select.Option>
                            <Select.Option key={"6"} value={6}>
                            Berichte/Abrechnung
                            </Select.Option>
                            <Select.Option key={"7"} value={7}>
                            Abrechnung
                            </Select.Option>
                        </Select>
                    </Descriptions.Item>
                    <Descriptions.Item label="" style={{width: "500px"}}>
                       
                    </Descriptions.Item>
                    <Descriptions.Item label="Actions">
                    {this.state.editing ? <Space><Button type='primary' onClick={this.handleSave} loading={this.state.loading}>Speichern</Button><Button onClick={() => this.setEditing(false)} type=''>Verwerfen</Button></Space> : <Button onClick={() => this.setEditing(true)} type='primary'>Bearbeiten</Button>}
                    </Descriptions.Item>
                    <Descriptions.Item label="Berichtjahr">
                        <Select
                            style={{
                                width: '150px'
                            }}
                            disabled
                            name="year"
                            placeholder={"Jahr"}
                            onChange={(val) => this.handleChange("projectYear", null, val)}
                            defaultValue={this.state.previousProjectYear.projectYear}>
                            {this
                                .state
                                .projectYears
                                .map(item => (
                                    <Select.Option key={item.projectYear} value={item.projectYear}>
                                        {item.projectYear}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Descriptions.Item>
                    <Descriptions.Item label="Phase">
                        <Select
                            style={{
                                width: '250px'
                            }}
                            name="currentPhase"
                            disabled={!this.state.editing1}
                            placeholder={"Phase"}
                            onChange={(val) => this.handleChange1("currentPhase", null, val)}
                            defaultValue={this.state.previousProjectYear.currentPhase}>
                            <Select.Option key={"1"} value={1}>
                                Plan
                            </Select.Option>
                            <Select.Option key={"2"} value={2}>
                            FG Evaluation 1
                            </Select.Option>
                            <Select.Option key={"3"} value={3}>
                            FG Änderungen
                            </Select.Option>
                            <Select.Option key={"4"} value={4}>
                            FG Evaluation 2
                            </Select.Option>
                            <Select.Option key={"5"} value={5}>
                            Vorstandsbewilligung
                            </Select.Option>
                            <Select.Option key={"6"} value={6}>
                            Berichte/Abrechnung
                            </Select.Option>
                            <Select.Option key={"7"} value={7}>
                            Abrechnung
                            </Select.Option>
                        </Select>
                    </Descriptions.Item>
                    <Descriptions.Item label="">
                                         </Descriptions.Item>
                    <Descriptions.Item label="Actions">
                    {this.state.editing1 ? <Space><Button type='primary' onClick={this.handleSave1}>Speichern</Button><Button onClick={() => this.setEditing1(false)} type=''>Verwerfen</Button></Space> : <Button onClick={() => this.setEditing1(true)} type='primary'>Bearbeiten</Button>}
                    </Descriptions.Item>

                </Descriptions>
                    <div className="rates-table-container">
                        <div className="rates-table-title">Tagessätze</div>
                        <table className="rates-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '15%' }}>Jahr</th>
                                    <th style={{ width: '25%' }}>Tagessatz Züchter</th>
                                    <th style={{ width: '25%' }}>Tagessatz Hilfskraft</th>
                                    <th style={{ width: '25%' }}>Tagessatz FG</th>
                                    <th style={{ width: '10%' }}>Aktionen</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><strong>{this.state.currentProjectYear.projectYear}</strong></td>
                                    <td>
                                        {this.state.editing2 ? (
                                            <InputNumber
                                                value={this.state.currentProjectYear.researcherRate}
                                                formatter={value => `${value} €`}
                                                parser={value => value.replace(' €', '')}
                                                onChange={(val) => this.handleChange("researcherRate", null, val)}
                                            />
                                        ) : (
                                            `${this.state.currentProjectYear.researcherRate} €`
                                        )}
                                    </td>
                                    <td>
                                        {this.state.currentProjectYear.projectYear >= 2027 ? (
                                            ""
                                        ) : (
                                            this.state.editing2 ? (
                                                <InputNumber
                                                    value={this.state.currentProjectYear.helperRate}
                                                    formatter={value => `${value} €`}
                                                    parser={value => value.replace(' €', '')}
                                                    onChange={(val) => this.handleChange("helperRate", null, val)}
                                                />
                                            ) : (
                                                `${this.state.currentProjectYear.helperRate} €`
                                            )
                                        )}
                                    </td>
                                    <td>
                                        {this.state.editing2 ? (
                                            <InputNumber
                                                value={this.state.currentProjectYear.fgRate}
                                                formatter={value => `${value} €`}
                                                parser={value => value.replace(' €', '')}
                                                onChange={(val) => this.handleChange("fgRate", null, val)}
                                            />
                                        ) : (
                                            `${this.state.currentProjectYear.fgRate} €`
                                        )}
                                    </td>
                                    <td>
                                        {this.state.editing2 ? (
                                            <Space>
                                                <Button type="primary" onClick={this.handleSaveRates}>Speichern</Button>
                                                <Button onClick={this.cancelEditingRates}>Verwerfen</Button>
                                            </Space>
                                        ) : (
                                            <Button type="primary" onClick={this.startEditingRates}>Bearbeiten</Button>
                                        )}
                                    </td>
                                </tr>
                                {this.state.showAllYears && 
                                    this.state.projectYears
                                        .filter(py => py.projectYear !== this.state.currentProjectYear.projectYear)
                                        .map(py => (
                                            <tr key={py.projectYear}>
                                                <td>{py.projectYear}</td>
                                                <td>{py.researcherRate} €</td>
                                                <td>{py.projectYear >= 2027 ? "" : `${py.helperRate} €`}</td>
                                                <td>{py.fgRate} €</td>
                                                <td></td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                        <a className="show-all-years-link" onClick={this.toggleShowAllYears}>
                            {this.state.showAllYears ? "zeige weniger Jahre" : "zeige alle Jahre"}
                        </a>
                    </div>
                    <Space>
                        <div>
                            Setzen Sie das aktuelle Projektjahr auf das nächste Kalenderjahr
                        </div> <br></br>
                        <Popconfirm
                            title={"Möchten Sie das Projektjahr wirklich erhöhen? Diese wird im nächsten Jahr in die Planphase gesetzt?"}
                            onConfirm={this.incrementYear}
                            onCancel={this.cancelPop}
                        >
                            <Button type='danger' >Nächstes Kalenderjahr</Button>
                        </Popconfirm>
                    </Space>
                </div>}
                
            </div>
        )
    }
}

export default ProjectSettings